export default __webpack_public_path__ + "static/media/documentation.36332eee.svg";